import React from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import { hexToRgba } from '../../services/hex.service';

export interface TablePaginationProps {
  pageChange: Function;
  pageCount: number;
  total: number;
  currentPage: number;
}

const StyledTablePagination = styled.div`
  border-top: 1px solid ${({ theme }) => hexToRgba(theme.colors.LABEL, 0.2)};
  background: ${({ theme }) => hexToRgba(theme.colors.BORDER, 0.4)};
  display: flex;
  align-items: center;
  padding: 12px 20px;

  .pagination {
    display: flex;
    align-items: center;

    &__page {
      width: 24px;
      height: 24px;
      margin: 0 2px;
      border-radius: 4px;
      cursor: pointer;
      border: 1px solid transparent;
      transition: background-color 0.3s, color 0.3s ease;

      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 16px;
        font-weight: 500;
      }

      :not(&_active):hover {
        background: ${({ theme }) => theme.colors.BORDER};
      }

      &_active {
        background: ${({ theme }) => theme.colors.BLUE.B400};
        color: white;

        a:hover {
          color: white;
        }
      }
    }
  }
`;

const TablePaginationComponent = ({
  pageCount = 0,
  currentPage = 0,
  total = 0,
  pageChange,
}: TablePaginationProps) => {
  const { t } = useTranslation();
  const handleChangePage = (data: { selected: number }) =>
    pageChange(data.selected + 1);

  return (
    <StyledTablePagination>
      <ReactPaginate
        forcePage={currentPage - 1}
        pageCount={pageCount || currentPage}
        breakLabel="..."
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handleChangePage}
        containerClassName="pagination"
        pageClassName="pagination__page"
        activeClassName="pagination__page_active"
        previousLabel={<></>}
        nextLabel={<></>}
        disabledClassName="pagination__controls_disable"
      />
    </StyledTablePagination>
  );
};

export default TablePaginationComponent;
